<template>
  <el-container class="energy-price" direction="vertical">
    <common-panel :panel-data="panelData"/>
  </el-container>
</template>

<script>
import CommonPanel from "../../common/panel/CommonPanel";

export default {
  name: "ProductValue",
  components: {CommonPanel},
  data() {
    return {
      panelData: {
        tableTitle: '产值配置列表',
        hasTree: false,
        hasTreeToolbar: false,
        queryMethod: this.$api.systemManage.getSiteProdValue,
        filterForm: [
          {label: '站点名称：', prop: 'siteName', type: 'input', value: '', style: 'width: 160px;margin-right: 10px;'},
          {label: '年份：', prop: 'prodYear', type: 'year', value: new Date().Format('yyyy'), style: 'width: 160px;margin-right: 10px;'}
        ],
        buttons: [
          {label: '设置产值', icon: 'zy-icon-setting-gear', type: 'updateRows', handleIndex: -2, text: true}
        ],
        methods: {
          edit: this.$api.systemManage.updateSiteProdValue,
          update_prop: 'id'
        },
        // tableCheck: true,
        tableProps: [
          {prop: "siteName", label: "站点名称", width: '200px'},
          {prop: "prodYear", label: "年份"},
          {prop: "prodValue1", label: "1月产值"},
          {prop: "prodValue2", label: "2月产值"},
          {prop: "prodValue3", label: "3月产值"},
          {prop: "prodValue4", label: "4月产值"},
          {prop: "prodValue5", label: "5月产值"},
          {prop: "prodValue6", label: "6月产值"},
          {prop: "prodValue7", label: "7月产值"},
          {prop: "prodValue8", label: "8月产值"},
          {prop: "prodValue9", label: "9月产值"},
          {prop: "prodValue10", label: "10月产值"},
          {prop: "prodValue11", label: "11月产值"},
          {prop: "prodValue12", label: "12月产值"}
        ],
        drawerTitle: '产值信息',
        dialogs: {
          add_edit: {
            title: '产值信息',
            width: '700px',
            items: [
              {type: 'input', prop: 'siteName', label: '站点：', style: 'width: 315px;', editable: true},
              {type: 'year', prop: 'prodYear', label: '年份：', value: new Date().Format('yyyy'), placeholder: '请选择年份', style: 'width: 315px;'},
              {type: 'input', prop: 'prodValue1', label: '1月产值(万元)：', placeholder: '请输入产值', style: 'width: 315px;'},
              {type: 'input', prop: 'prodValue2', label: '2月产值(万元)：', placeholder: '请输入产值', style: 'width: 315px;'},
              {type: 'input', prop: 'prodValue3', label: '3月产值(万元)：', placeholder: '请输入产值', style: 'width: 315px;'},
              {type: 'input', prop: 'prodValue4', label: '4月产值(万元)：', placeholder: '请输入产值', style: 'width: 315px;'},
              {type: 'input', prop: 'prodValue5', label: '5月产值(万元)：', placeholder: '请输入产值', style: 'width: 315px;'},
              {type: 'input', prop: 'prodValue6', label: '6月产值(万元)：', placeholder: '请输入产值', style: 'width: 315px;'},
              {type: 'input', prop: 'prodValue7', label: '7月产值(万元)：', placeholder: '请输入产值', style: 'width: 315px;'},
              {type: 'input', prop: 'prodValue8', label: '8月产值(万元)：', placeholder: '请输入产值', style: 'width: 315px;'},
              {type: 'input', prop: 'prodValue9', label: '9月产值(万元)：', placeholder: '请输入产值', style: 'width: 315px;'},
              {type: 'input', prop: 'prodValue10', label: '10月产值(万元)：', placeholder: '请输入产值', style: 'width: 315px;'},
              {type: 'input', prop: 'prodValue11', label: '11月产值(万元)：', placeholder: '请输入产值', style: 'width: 315px;'},
              {type: 'input', prop: 'prodValue12', label: '12月产值(万元)：', placeholder: '请输入产值', style: 'width: 315px;'}
            ],
            rules: {
              prodYear: [
                {required: true, message: '请选择年份', trigger: 'blur'}
              ]
            },
            confirmMethod: null
          }
        }
      }
    }
  }
}
</script>

<style scoped>
  .energy-price{
    width: 100%;
    height: 100%;
  }
  .el-menu{
    background: white;
  }
  .el-menu .el-menu-item{
    font-size: 16px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/SystemSetting/ProductValue.vue